import { ReactComponent as RefineBeforePublishGraphic } from "@/components/ui/icons/refine-before-publish.svg";
import { WorkflowDialog } from "@faro-lotv/data-management";
import { FaroButton, FaroDialogProps } from "@faro-lotv/flat-ui";
import { RegistrationRevision } from "@faro-lotv/service-wires";
import { JSX } from "react";
import {
  useRefineRegistration,
  useSaveUserEdits,
} from "../../inspect-and-publish/refine-and-publish-utils";

type StartRefinementDialogProps = Pick<FaroDialogProps, "open"> & {
  /** The current revision to refine. */
  revision: RegistrationRevision;
  /** Called when the user dismisses the dialog without making a choice. */
  onCancel(): void;
};

/**
 * @returns A dialog stating to the user that the refinement could be a long running operation.
 *   This is shown when the user explicitly starts the refinement process (by clicking on refine registration)
 */
export function StartRefinementDialog({
  revision,
  onCancel,
  ...dialogProps
}: StartRefinementDialogProps): JSX.Element {
  const { saveUserEdits } = useSaveUserEdits();
  const { isRefinementRunning, refine } = useRefineRegistration(
    revision,
    saveUserEdits,
  );

  return (
    <WorkflowDialog
      variant="action"
      title="Start Refinement?"
      description={
        <>
          We're taking care of refining your changes to enhance quality. It may
          take a little while, you can check the current status anytime in the
          Progress view.
        </>
      }
      image={RefineBeforePublishGraphic}
      actions={
        <>
          <FaroButton
            variant="ghost"
            onClick={onCancel}
            disabled={isRefinementRunning}
          >
            Cancel
          </FaroButton>
          <FaroButton
            variant="primary"
            onClick={refine}
            isLoading={isRefinementRunning}
          >
            Refine
          </FaroButton>
        </>
      }
      {...dialogProps}
    />
  );
}
